<template>
  <div id="user_active_vue">
    <el-table
      :data="tableData"
      style="width: 100%"
      class="fc-000000"
      empty-text=" "
    >
      <el-table-column prop="data" label="Name" width="200" sortable>
        <template slot-scope="scope">
          <div class="fs-14 ellipsis">
            {{ scope.row.firstname }} {{ scope.row.lastname }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="data" label="Email Addresss" width="200" sortable>
        <template slot-scope="scope">
          <div class="fs-14 ellipsis">{{ scope.row.email }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="data"
        label="Last Active Date and Time"
        align="right"
        header-align="right"
         width="214"
        sortable
      >
        <template slot-scope="scope">
          <div class="fs-14">{{ scope.row.lastDate+" at "+scope.row.time }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "userActive",
  props: {
    tableData: Array,
  },
};
</script>

<style lang="scss">
#user_active_vue {
  .el-table tr,
  .el-table,
  .el-table th.el-table__cell {
    background-color: transparent;
  }
}
</style>